var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.value),function(item){return _c('v-col',{key:'item'+item.value,attrs:{"cols":"12","sm":"4"}},[_c('FreespinsGameSimpleCard',{attrs:{"item":item},on:{"close":function($event){return _vm.removeItem(item.value)}}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }